// extracted by mini-css-extract-plugin
module.exports = {"perspectiveBar":"PerspectiveBar_perspectiveBar__2FQma"};